import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const DragDropContext = createContext(undefined);
export const DragDropProvider = ({ children }) => {
    const [draggedSectionId, setDraggedSectionId] = useState(null);
    const [dragOverSectionId, setDragOverSectionId] = useState(null);
    const [dragOverSectionDropZone, setDragOverSectionDropZone] = useState(null);
    const [draggedSlideId, setDraggedSlideId] = useState(null);
    const [dragOverDropZone, setDragOverDropZone] = useState(null);
    const [hoveredSlideId, setHoveredSlideId] = useState(null);
    const [originalSectionOrder, setOriginalSectionOrder] = useState(new Map());
    const [originalSlideOrders, setOriginalSlideOrders] = useState(new Map());
    const value = {
        draggedSectionId,
        dragOverSectionId,
        dragOverSectionDropZone,
        draggedSlideId,
        dragOverDropZone,
        hoveredSlideId,
        originalSectionOrder,
        originalSlideOrders,
        setDraggedSectionId,
        setDragOverSectionId,
        setDragOverSectionDropZone,
        setDraggedSlideId,
        setDragOverDropZone,
        setHoveredSlideId,
        setOriginalSectionOrder,
        setOriginalSlideOrders,
    };
    return _jsx(DragDropContext.Provider, { value: value, children: children });
};
export const useDragDrop = () => {
    const context = useContext(DragDropContext);
    if (!context) {
        throw new Error("useDragDrop must be used within a DragDropProvider");
    }
    return context;
};
